/* Uses the original Dawn form. Variant, stock, quantity and name remain native. */
(()=>{
 let controller=null;
 function mount(){
   controller?.destroy();controller=null;
   const product=document.querySelector('product-info[id^="MainProduct-"]');
   if(!product||!window.MpcMobileBuy)return;
   const form=product.querySelector('product-form form'),button=form?.querySelector('[name="add"]');
   if(!form||!button)return;
   const priceBox=()=>product.querySelector('[id^="price-"]');
   function price(){const box=priceBox();const sale=box?.querySelector('.price.price--on-sale .price-item--sale');const regular=box?.querySelector('.price__regular .price-item--regular');return (sale||regular)?.textContent.trim()||'';}
   controller=MpcMobileBuy.attach({form,button,price,title:product.querySelector('.product__title h1')?.textContent.trim()||'Votre sélection',watchRoot:product,hasVariant:()=>Boolean(form.querySelector('[name="id"]')?.value)});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount);else mount();
 document.addEventListener('shopify:section:load',mount);
 document.addEventListener('shopify:section:unload',event=>{if(event.target.querySelector('product-info[id^="MainProduct-"]')){controller?.destroy();controller=null;}});
})();
